export default __webpack_public_path__ + "static/media/green_rocket.8d38fb14.svg";